<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; height: 100%">
  <iframe *ngIf="url$ | async as url" [src]="url | safeResourceUrl" [ngClass]="{'disable-mouse-events' : isContextPanelResizing}" style="background-color: white;" sandbox=""></iframe>
</div>
